module.exports = __webpack_public_path__ + "static/media/vahid-ghodsi-s.a1bce810.jpg";